// extracted by mini-css-extract-plugin
module.exports = {"message":"style_message__A0qrK","icon":"style_icon__hNNFv","title":"style_title__11mkX"};